import { CalendarEventDataMapper } from "@inthraction/data-mappers";

export class CalEvent implements CalendarEventDataMapper {
  __typename: string = "CalendarEvent";
  organizationID;
  employeeID;
  attendeeEmails?;
  attendees?;
  calendarId;
  deleted?;
  description?;
  end;
  eventCreated;
  eventStatus?;
  eventUpdated?;
  id;
  locationDescription?;
  meetingURL?;
  options?;
  organizer?;
  organizerEmail?;
  participationStatus?;
  private?;
  recurring?;
  start;
  status?;
  summary?;
}
